<template>
<div>
    <header id="header" :data-html2canvas-ignore="true">
        <h1>
          <div class="group-image-logo">
            <img :src="crepologo" @click="goToHome" :alt="$t('default_title')" class="crepologo">
            <HeaderBrandTagline />
          </div>
        </h1>
        <ul class="subnavi">
            <template v-if="$route.name !== 'Plug' && authUser && authUser.id">
                <template v-if="authUser">
                    <li v-if="showGenerationHistory" class="generation-history-item">
                        <GeneratedHistoryPopup />
                    </li>
                    <li>
                        <div class="btn-group-plan">
                            <template v-if="authUser.plan && (authUser.plan.plan_type === planFree || authUser.plan.plan_type === planTrial)">
                                <div class="plan-wrapper">
                                    <div>
                                        <div v-if="hasSubscribedPlan(authUser)" class="d-flex align-items-center">
                                            <span :class="[isPlanExpired ? 'icon-ai-valuation' : 'icon-ai-valuation-red']"></span>
                                            <span>{{authUser.plan[`name${getCurrentLanguage != 'ja' ? `_${getCurrentLanguage}` : ''}`]}}</span>
                                        </div>
                                        <div v-if="hasSubscribedPlanGenerate(authUser)" class="d-flex align-items-center">
                                            <span :class="[isUserPlanGenerate ? 'icon-plan-generate-red' : 'icon-plan-generate']"></span>
                                            <span>{{authUser.plan_generate[`name${getCurrentLanguage != 'ja' ? `_${getCurrentLanguage}` : ''}`]}}</span>
                                        </div>
                                      <template v-if="authUser.plan.plan_type === planFree">
                                        <a @click="changePlan()" class="btn-choose-plan">{{ $t('special_plan') }}</a>
                                        <a
                                          v-if="shouldShowChangeToUnlimitedPlan()"
                                          @click="changePlan()"
                                          class="btn-choose-plan"
                                        >{{ getGenerateTrialPlanChangeButtonLabel() }}</a>
                                      </template>
                                      <template v-else-if="authUser.plan.plan_type === planTrial">
                                        <a @click="goToUpdateInfoUserTrial()" class="btn-choose-plan">{{ $t('change_to_special_plan_from_trial') }}</a>
                                      </template>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <span class="plan-name">{{ $t('current_plan') }}</span>
                                <div class="plan-wrapper">
                                    <div>
                                        <div v-if="hasSubscribedPlan(authUser)" class="d-flex align-items-center">
                                            <span :class="[isPlanExpired? 'icon-ai-valuation' : 'icon-ai-valuation-red']"></span>
                                            <span>{{authUser.plan[`name${getCurrentLanguage != 'ja' ? `_${getCurrentLanguage}` : ''}`]}}</span>
                                        </div>
                                        <div v-if="hasSubscribedPlanGenerate(authUser)" class="d-flex align-items-center">
                                            <span :class="[isUserPlanGenerate ? 'icon-plan-generate-red' : 'icon-plan-generate']"></span>
                                            <span>{{authUser.plan_generate[`name${getCurrentLanguage != 'ja' ? `_${getCurrentLanguage}` : ''}`]}}</span>
                                        </div>
                                    </div>
                                    <i v-if="isAdmin && authUser.setting_plan" class="fa far fa-edit icon-change-plan" @click="goToPlanRenew"></i>
                                </div>
                                <a
                                  v-if="shouldShowChangeToUnlimitedPlan()"
                                  @click="changePlan()"
                                  class="btn-choose-plan"
                                >{{ getGenerateTrialPlanChangeButtonLabel() }}</a>
                                <div v-if="showMaxImage">{{ $t('limit', { max_images: maxImagesOfUser}) }}</div>
                            </template>
                        </div>
                    </li>
                </template>
                <template v-if="!isSuperAdmin">
                    <li>
                        <router-link :to="{name: (isAdmin ? 'MypageIndex' : 'Users')}">{{ $t('my_page') }}</router-link>
                    </li>
                </template>
                <li>
                    <a @click="logout"><i class="fa fa-sign-out pr5"></i>{{ $t('logout') }}</a>
                </li>
            </template>
            <template v-else>
                <li>
                    <a @click="logout"><i class="ti-lock pr5"></i>{{ $t('click_here_for_member') }}</a>
                </li>
            </template>
        </ul>
    </header>
    <div class="body-inner">
        <router-view :key="$route.fullPath" />
    </div>
    <footer class="footer">

    </footer>
    <GenerationHistorySidebar />
</div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex';
import '@/assets/backend_js/js/jquery.dataTables.min';
import '@/assets/backend_js/js/dataTables.bootstrap.min';
import '@/assets/backend_js/js/dataTables.buttons.min';
// Lazy loading mixin for heavy libraries
import lazyLibraryMixins from '@/shared/mixins/lazyLibraryMixins';
import constants from '@/shared/constants/constants.js';
import HeaderBrandTagline from '@/shared/components/HeaderBrandTagline.vue';
import GeneratedHistoryPopup from '@/shared/components/GeneratedHistoryPopup.vue';
import GenerationHistorySidebar from '@/shared/components/GenerationHistorySidebar.vue';
import {
    logout
} from '@/services/user.service';
import { maxImageSetting } from '../services/setting.service';
import { formatMaxImage } from '@/shared/filters';
import commonPageMixins from '../shared/mixins/commonPageMixins';
import {
  hasSubscribedPlan,
  hasSubscribedPlanGenerate,
  isGenerateFreeTrialWithoutUserInfo,
  isTimeExpired,
  shouldShowChangeToUnlimitedPlan,
  shouldShowGenerationHistory,
} from '../shared/functions';
import crepologo from '@/assets/img/login/crepologo.png';

export default {
    name: 'BackendLayout',
    mixins: [commonPageMixins, lazyLibraryMixins],
    components: {
      HeaderBrandTagline,
      GeneratedHistoryPopup,
      GenerationHistorySidebar,
    },
    data() {
        return {
            planFree: constants.PLAN_TYPE_FREE,
            planTrial: constants.PLAN_TYPE_TRIAL,
            planAdhoc: constants.PLAN_TYPE_ADHOC,
            createProductLanguage: constants.PRODUCT_SERVICE_LANGUAGE,
            crepologo,
        };
    },
    computed: {
        ...mapState([
            'authUser',
        ]),
        ...mapGetters([
            'isSuperAdmin',
            'isAdmin',
            'isReachLimited',
            'isUserAdhoc',
            'isUserNotFee',
            'isUserPlanGenerate',
            'getCurrentLanguage',
            'maxImagesOfUser',
            'isUserPlanMonth',
            'getMaxImageSetting',
            'isValuationPlanExpired',
        ]),
        showMaxImage() {
          const maxImage = formatMaxImage(this.authUser, this.getMaxImageSetting, false);
          return this.isUserPlanMonth && maxImage !== null && !this.isValuationPlanExpired;
        },
        isPlanExpired() {
          if (this.authUser.plan && this.authUser.plan.plan_type === constants.PLAN_TYPE_ADHOC) {
            return false;
          }
          return isTimeExpired(this.authUser.expired_at);
        },
        showGenerationHistory() {
          return shouldShowGenerationHistory(this.authUser, this.isUserPlanGenerate);
        },
    },
    created() {
        $.extend($.fn.dataTable.defaults, {
            language: {
                url: `${location.origin}/static/i18n/ja.json`,
            },
        });
        this.fetchMaxImageSetting();
    },
    mounted() {
        // Preload libraries
        this.preloadLibrariesBasedOnPermissions();
    },
    methods: {
        logout() {
            localStorage.removeItem('result');
            const token = localStorage.getItem('token');
            logout(token);
            this.$store.dispatch('logout');
            this.$router.push({
                name: 'Login'
            });
        },
        createProject() {
            if (this.isUserAdhoc && this.$store.state.projectId > 0) {
                let answer = confirm(this.$t('message.additional_fee'));
                if (answer) {
                    this.resetDataProject();
                    window.location.href = '/home';
                }
            } else {
                this.resetDataProject();
                window.location.href = '/home';
            }
        },
        changePlan() {
            if (this.$route.name === 'PlanRenew') return;
            if (this.shouldGoToUpdateInfoForGenerateTrial()) {
                this.goToUpdateInfoUserTrial();
                return;
            }
            this.$router.push({
                name: 'PlanRenew',
                params: {
                    hot_change: true,
                    lastPage: this.$route.name
                }
            });
        },
        shouldShowChangeToUnlimitedPlan() {
          return shouldShowChangeToUnlimitedPlan(this.authUser, this.isUserPlanGenerate);
        },
        shouldGoToUpdateInfoForGenerateTrial() {
          return isGenerateFreeTrialWithoutUserInfo(this.authUser, this.isUserPlanGenerate);
        },
        getGenerateTrialPlanChangeButtonLabel() {
          if (this.shouldGoToUpdateInfoForGenerateTrial()) {
            return this.$t('plan_change_for_generate_trial');
          }
          return this.$t('special_plan_unlimited');
        },
        goToUpdateInfoUserTrial() {
            if (this.$route.name === 'UpdateInfoUserTrial') return;
            this.$router.push({
                name: 'UpdateInfoUserTrial',
                params: {
                    hot_change: true,
                    lastPage: this.$route.name
                }
            });
        },
        goToPlanRenew() {
            if (this.$route.name === 'PlanRenew') return;
            if (this.shouldGoToUpdateInfoForGenerateTrial()) {
                this.goToUpdateInfoUserTrial();
                return;
            }
            this.$router.push({ name: 'PlanRenew' });
        },
        goToHome() {
          if (this.isSuperAdmin) {
            window.location.href = '/';
          } else {
            window.location.href = '/home';
          }
        },
        resetDataProject() {
          this.$store.state.menuChecked = null;
          this.$store.state.paramsLastRoute = {};
          this.$store.state.paramsLastStep = {};
          this.$store.state.currentImageUpload = [];
          this.$store.state.pathCurrentImageUpload = [];
          this.$store.state.segmentChecked = [];
          this.$store.state.currentImageUsed = 0;
          this.$store.state.projectId = 0;
        },
        async fetchMaxImageSetting() {
          const { status, data } = await maxImageSetting();
          if (status === constants.HTTP_OK) {
            this.$store.state.maxImageSetting = data;
          }
        },
        hasSubscribedPlan,
        hasSubscribedPlanGenerate,

        // Lazy loading methods for additional assets
        async loadButtonsFlash() {
            await this.loadAssetFile('buttons.flash.min');
        },

        async loadJszip() {
            await this.loadAssetFile('jszip.min');
        },

        async loadPdfmake() {
            await this.loadAssetFile('pdfmake.min');
        },

        async loadVfsFonts() {
            await this.loadAssetFile('vfs_fonts');
        },

        async loadButtonsHtml5() {
            await this.loadAssetFile('buttons.html5.min');
        },

        async loadButtonsPrint() {
            await this.loadAssetFile('buttons.print.min');
        },

        async loadNatural() {
            await this.loadAssetFile('natural.js');
        },

        // Preload additional libraries
        async preloadLibrariesBasedOnPermissions() {
            await Promise.all([
                this.loadPdfmake(),
                this.loadVfsFonts(),
                this.loadButtonsHtml5(),
                this.loadButtonsFlash(),
                this.loadButtonsPrint(),
                this.loadJszip(),
                this.loadNatural()
            ]);
        }
    },
};
</script>

<style lang="scss">
@import url('./../assets/backend_css/css/common/toastr.css');
@import url('./../assets/backend_css/css/common/dataTables.bootstrap.min.css');
@import url('./../assets/css/common/style_pc.css');
@import url('./../assets/css/common/style_sp.css');
@import url('./../assets/backend_css/css/mypage/mypage_pc.css');
@import url('./../assets/backend_css/css/mypage/mypage_sp.css');
@import url('./../assets/backend_css/css/common/buttons.dataTables.min.css');

a {
    cursor: pointer;
}

.router-link-exact-active {
    color: #77bae1;
}

.btn-group-plan {
    text-align: center;
    height: 95px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 10px;

    span {
        display: block;
    }

    .btn-choose-plan {
        background-color: green;
        color: white;
        height: 25px;
        line-height: 25px;
        padding: 0 10px;
    }
}
.mg20 {
  margin: 10px 20px !important;
}
.plan-name {
  font-size: 11px;
  font-weight: bold;
  color: #0d47a1;
}
</style>

<style lang="scss" scoped>
#header {
  h1 {
    padding: 0 !important;
    .group-image-logo {
      display: flex;
      align-items: center;
    }
    @media (min-width: 900px){
      .group-image-logo {
        height: 80px;
      }
    }
    @media (max-width: 900px){
      .group-image-logo {
        height: 50px;
      }
    }
  }
}

.align-items-center {
  align-items: center;
}
.crepologo {
  cursor: pointer;
}
</style>
